export const buildTooltipDateHeader = (formattedDate: string): string =>
  `<div style="font-size: 10px; color: white; font-weight: 100; line-height: 12px; letter-spacing: -0.02em; padding-bottom: 5px;">${formattedDate}</div>`;

export const buildTooltipSeriesRow = ({
  marker,
  color,
  name,
  value,
  location,
}: {
  marker: string;
  color: string;
  name: string;
  value: unknown;
  location?: string;
}): string => `
  <div style="display: flex; flex-direction: column;">
    <div style="display: flex; gap: 0 5px; justify-content: space-between; align-items: center">
      <div style="display: flex; gap: 0 5px; align-items: center">
        <span style="color: ${color};">${marker}</span>
        <span style="color: white; font-weight: 100;">${name}</span>
      </div>
      <span style="color: white; font-weight: 800;">${value}</span>
    </div>
    ${
      location != null
        ? `<span style="padding-left: 20px; color: white; font-size: 10px; margin-top: -3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex-grow: 1; flex-shrink: 1;">${location}</span>`
        : ""
    }
  </div>`;

export const buildTooltipAlarmSeriesRow = ({
  marker,
  value,
}: {
  marker: string;
  value: unknown;
}): string => `
  <div style="margin-bottom: 5px; display: flex; gap: 0 5px; justify-content: space-between; align-items: center">
    <div style="display: flex; gap: 0 5px; align-items: center">
      <span style="color: #027680;">${marker}</span>
    </div>
    <span style="color: white; font-weight: 800;">${value}</span>
  </div>`;
